// extracted by mini-css-extract-plugin
module.exports = {"BooleanFeature":"wk_a bhv_b"};